import { useColorModeValue } from '@chakra-ui/color-mode';
import { Image } from '@chakra-ui/image';
import { Box, Center, SimpleGrid, Stack, Text } from '@chakra-ui/layout';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { SKILLS } from '../utils/constants';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Card = ({ label, icon }) => {
	AOS.init();

	return (
		<Box
			p={5}
			bg='red.200'
			borderRadius='xl'
			minWidth={{ base: '280px', sm: '200px', md: '280px' }}
			maxWidth={{ base: '300px', md: '350px' }}
			shadow='xlg'
			background={useColorModeValue('gray.200', 'gray.600')}
			color={useColorModeValue('black', 'white')}
			transition='all 0.15s'
			_hover={{
				shadow: 'md',
				transform: 'translateY(-5px)',
				cursor: 'normal'
			}}
			alignContent={'center'}
		>
			<Stack direction='row' align='center' spacing={3}>
				<Image boxSize='50px' src={`/images/${icon}`} alt={icon} loading='lazy' />
				<Text>{label}</Text>
			</Stack>
		</Box>
	);
};

const Skills = () => {
	useDocumentTitle();
	AOS.init();

	return (
		<Box
			background={useColorModeValue('gray.50', 'gray.800')}
			minHeight={{ md: 'calc(100vh - 120px)' }}
			pl={9} 
			pr={9}
			pt={10}
		>
			<div data-aos="fade-down" data-aos-anchor-easing='ease-in-out' data-aos-anchor-placement="top-center" px={9}>
				<Center>
					<Text>
						Here are some{' '}
						<Text
							display='inline'
							borderBottomColor='red.500'
							borderBottomWidth='2px'
							borderBottomRadius='2px'
							pb='0.1rem'
						>
							languages/frameworks
						</Text>{' '}
						I've worked with professionally and am familiar with!
					</Text>
				</Center>
				<Box p={{ base: 3, md: 10 }}>
					<Center>
						<SimpleGrid
							spacing={{ base: '5', md: '8' }}
							columns={{ base: 1, sm: 2, lg: 3 }}
						>
							{SKILLS.map((skill) => (
								<Card {...skill} key={skill.label} />
							))}
						</SimpleGrid>
					</Center>
				</Box>
			</div>
		</Box>
	);
};

export default Skills;
